import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const SalesforceM360 = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    try {
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    }
    
    const queryParams = new URLSearchParams(location.search);
    const caeQMemID = queryParams.get('memqnxtid');
    const memberLastName = queryParams.get('MemberLastName');
    const memberFirstName = queryParams.get('MemberFirstName');
    const systemId = queryParams.get('SystemId');
    const userId = queryParams.get('UserId');
    const roleTypeId = queryParams.get('RoleTypeId');
    const cookieKey = queryParams.get('WinSSOKey'); 
    const Module = queryParams.get('module') || ''; 
    
    fetchSalesforceM360URL(caeQMemID, memberLastName, memberFirstName, systemId, userId, roleTypeId, cookieKey, Module);
  }, [location]);

  const fetchSalesforceM360URL = async (caeQMemID, memberLastName, memberFirstName, systemId, userId, roleTypeId, cookieKey, Module) => {
    try {
      const response = await axios.get(`${API_URL}/api/SalesforceM360/GetSalesforceM360Url`, {
        params: {
          CaeQMemID: caeQMemID || '',
          MemberLastName: memberLastName || '',
          MemberFirstName: memberFirstName || '',
          SystemId: systemId || '',
          UserId: userId || '',
          RoleTypeId: roleTypeId || '',
          CookieKey: cookieKey || '',
          Module: Module || 'SalesforceM360'
        }
      });

      setLoading(false);
      
      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      } else {
        setError('salesforce');
      }
    } catch (error) {
      console.error('Error fetching Salesforce M360 URL:', error);
      setError('salesforce');
      setLoading(false);
    }
  };

  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0">
        <tbody>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {error && <ErrorPage errorType="salesforce" />}
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'large'}}>
              {loading && (
                <div>
                  <div style={{float: 'left'}}>
                    <img src={LoadingImage} id="loadinggif" alt="Loading" />
                  </div>
                  <div style={{float: 'left'}} id="loadingtext">
                    Loading...
                  </div>
                </div>
              )}
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SalesforceM360;